import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Gift, X, ArrowRight } from 'lucide-react';

/**
 * Persistent slim banner above the nav advertising the monthly free chapter.
 * Dismissable per visitor, persists in localStorage. Resets if month changes.
 */
const STORAGE_KEY = 'tav-gift-banner-dismissed-v1';

export default function GiftBanner() {
  const [dismissed, setDismissed] = useState(() => {
    try { return typeof window !== 'undefined' && localStorage.getItem(STORAGE_KEY) === '1'; }
    catch { return false; }
  });
  const [hideOnGiftPage, setHideOnGiftPage] = useState(false);

  // Hide when already on /gift or /gift/read
  useEffect(() => {
    const update = () => {
      const p = window.location.pathname;
      setHideOnGiftPage(p.startsWith('/gift'));
    };
    update();
    window.addEventListener('popstate', update);
    // Re-check on every render path change (router push doesn't fire popstate)
    const interval = setInterval(update, 800);
    return () => {
      window.removeEventListener('popstate', update);
      clearInterval(interval);
    };
  }, []);

  if (dismissed || hideOnGiftPage) return null;

  const handleDismiss = (e) => {
    e.preventDefault();
    e.stopPropagation();
    try { localStorage.setItem(STORAGE_KEY, '1'); } catch { /* ignore */ }
    setDismissed(true);
  };

  return (
    <Link to="/gift" className="gift-banner" data-testid="gift-banner" aria-label="Get this month's free chapter">
      <div className="gift-banner-inner">
        <Gift size={14} strokeWidth={2.2} className="gift-banner-icon" />
        <span className="gift-banner-text">
          <strong>Free this month:</strong> Chapter 1 of <em>F.U.C.K. T.H.A.T.T.</em>
        </span>
        <span className="gift-banner-cta">
          Get yours <ArrowRight size={13} strokeWidth={2.4} />
        </span>
      </div>
      <button
        type="button"
        className="gift-banner-close"
        data-testid="gift-banner-close"
        onClick={handleDismiss}
        aria-label="Dismiss banner"
      >
        <X size={14} strokeWidth={2.2} />
      </button>
    </Link>
  );
}
